import React, { useEffect, useState } from "react";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";
import { Constants } from "../../../CommonMethhods/Constants";
import { DASHBOARD_EQUITY } from "../../../Configuration/API_URL";
import Loader from "../../Common/Loader";
import axiosInstance from "../../../CommonMethhods/axiosInstance";

function IpoDetail() {
  const storeToken = localStorage.getItem("ssoToken");
  const [serverError, setServerError] = useState("");
  const [ipoDetail, setIpoDetail] = useState([]);
  const [loader, setLoader] = useState(true);

  const getIpoDetail = async () => {
    let payloadValue = {};
    let encPayload = AESEncryption(payloadValue);
    try {
      const getDetail = await axiosInstance.post(
        DASHBOARD_EQUITY.IpoDetails_URL,
        `"${encPayload}"`,
      );
      const res = ApiResDecrypt(getDetail?.data);
      if (res?.status === 0) {
        setIpoDetail(res?.data?.ipo);
      } else {
        setIpoDetail([]);
        setServerError(res?.message);
      }
    } catch (error) {
      console.log(error);
      setServerError(error?.message);
    } finally {
      setLoader(false);
    }
  };
  useEffect(() => {
    getIpoDetail();
  }, []);

  return (
    <>
      <div className="card-box">
        <div className="card-title">
          <h2>{Constants.IPO_Details}</h2>
        </div>
        <div className="ipo-detail-wrapper">
          <div className="scroll-table active-table">
            {loader ? (
              <div className="loader-alignment">
                <Loader />
              </div>
            ) : ipoDetail.length > 0 ? (
              <table className="table">
                <thead>
                  <tr>
                    <th>{Constants.Company_Name}</th>
                    <th>{Constants.Number_Subscription}</th>
                    <th>{Constants.Lots_Subscribed}</th>
                  </tr>
                </thead>
                <tbody>
                  {ipoDetail.map((ipo, index) => {
                    return (
                      <tr key={index}>
                        <td>{ipo.compName ? ipo.compName : "-"}</td>
                        <td>{ipo.subscribers}</td>
                        <td>{ipo["lotsdone "] ? ipo["lotsdone "] : "-"}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              serverError && (
                <h4 className="no-data">{noDataFound(serverError)}</h4>
              )
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default IpoDetail;
